import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'

import LoaderSkeleton from '~/shared/components/LoaderSkeleton'
import { AppLanguage } from '~/types/locale'

import useWeeklyTimeSpentReport from '../hooks/useWeeklyTimeSpentReport'

import WeeklyChartBar from './WeekyChartBar'

const WeeklyChart = (): React.ReactElement => {
  const { t } = useTranslation(['statistics', 'dashboard'])
  const { locale } = useRouter()

  const {
    data: { averageValue, dailyUseData, weekNumber, max, zeroData },
    isLoading,
    isError,
  } = useWeeklyTimeSpentReport()

  if (isLoading) {
    return <LoaderSkeleton className="h-65 w-full rounded-2.5 my-4" rows={1} />
  }

  return (
    <div className="bg-purple-cosmos border border-white-veil h-full w-full rounded-4 px-1 md:px-2.5 py-2 md:py-3">
      {!isError ? (
        <>
          <div className="flex flex-col gap-2 md:px-2 pt-1">
            <div className="flex justify-between items-center px-1">
              <h2 className="font-bold text-sm">{t('dashboard:timeSpent')}</h2>
              <span className="text-3.25 text-gray-200">
                {t('chart.week')} {weekNumber}
              </span>
            </div>
            <p className="px-1 font-semibold text-3.25">
              {t('chart.average')}: {averageValue} {t('chart.minutes')} {t('chart.per-day')}
            </p>
          </div>
          <div className="mt-5 md:mt-2">
            <WeeklyChartBar
              dailyUseData={dailyUseData}
              initialText={[t('chart.noDataText1'), t('chart.noDataText2')]}
              language={locale as AppLanguage}
              max={max}
              zeroData={zeroData}
            />
          </div>
        </>
      ) : (
        <p>Something is wrong</p>
      )}
    </div>
  )
}

export default WeeklyChart
